import type { ReactNode } from 'react';
import { CHIP_CLASS, DOT_CLASS, type Tone } from '../lib/status';

/**
 * Chip — the visual voice of the status design language.
 *
 * `data-tone` is on the element so tests (and future visual regression) can
 * assert the semantic tone rather than matching a Persian string alone.
 */
export interface ChipProps {
  tone: Tone;
  label: ReactNode;
  dot?: boolean;
  title?: string;
  className?: string;
}

export function Chip({ tone, label, dot = true, title, className = '' }: ChipProps) {
  return (
    <span
      className={`${CHIP_CLASS[tone]} ${className}`}
      data-tone={tone}
      data-testid="chip"
      title={title}
    >
      {dot ? <i className={DOT_CLASS[tone]} aria-hidden="true" /> : null}
      <span>{label}</span>
    </span>
  );
}

/** Bare colour marker for legends and dense rows. */
export function Dot({ tone, className = '' }: { tone: Tone; className?: string }) {
  return <i className={`${DOT_CLASS[tone]} ${className}`} data-tone={tone} aria-hidden="true" />;
}

export type ChipTone = Tone;
